import * as urlWebService from "utils/apis"
import * as actionsWebService from "utils/functions/httpMethods"

// Get all clients
export const getAllClients = async () => {
  try {
    const results = await actionsWebService.get(urlWebService.FIND_ALL_CLIENTS)
    return results
  } catch (error) {
    return error
  }
}

// Search clients
// filters: { fullName, email, phoneNumber }
export const searchClients = async (searchTerm = "") => {
  try {
    const results = await actionsWebService.get(
      `${urlWebService.SEARCH_CLIENTS}?query=${encodeURIComponent(searchTerm)}`
    )
    return results
  } catch (error) {
    return error
  }
}

// Get client
export const getClientById = async (clientId) => {
  try {
    const results = await actionsWebService.get(urlWebService.GET_CLIENT(clientId))
    return results
  } catch (error) {
    return error
  }
}

// Create client
export const createClient = async (payload) => {
  try {
    const results = await actionsWebService.postSafe(urlWebService.CREATE_CLIENT, payload)
    return results
  } catch (error) {
    throw error
  }
}

// Update client
export const updateClient = async (clientId, payload) => {
  try {
    const results = await actionsWebService.updateSafe(urlWebService.UPDATE_CLIENT(clientId), payload)
    return results
  } catch (error) {
    throw error
  }
}

// Delete client
export const deleteClient = async (clientId) => {
  try {
    const results = await actionsWebService.remove(urlWebService.DELETE_CLIENT(clientId))
    return results
  } catch (error) {
    return error
  }
}
